export default {
    es: {
        messages: {
            required: 'El campo es obligatorio',
            email: 'Ingresa un correo electrónico válido',
            regex: 'El formato no es válido',
            min_value: (field, value) => `El campo debe de ser ${value} o mayor`,
            max_value: (field, value) => `El campo debe de ser ${value} o menor`,
            min: (field, [length]) => `El campo debe tener al menos ${length} caracteres.`,
            max: (field, [length]) => `El campo no debe ser mayor a ${length} caracteres.`,
            numeric: (field) => `El campo debe contener solo caracteres númericos.`,
            digits: (field, [length]) => `El campo debe ser númerico y contener exactamente ${length} dígitos.`,
            decimal: (field) => `El campo debe ser numérico y contener 2 puntos decimales.`
        },
        custom: {
            'user[email]': {
                email: 'Ingresa un correo electrónico válido' // messages can be strings as well.
            },
            'user[password]': {
                min: (field, args) => `Tu contraseña debe ser de mínimo ${args[0]} caracteres`
            },
            'user[password_confirmation]': {
                confirmed: (field, args) => 'Tus contraseñas no coinciden'
            },
            'user[mobile_phone]': {
                digits: 'El campo debe ser númerico y contener exactamente 10 dígitos.'
            }
        }
    }
}